import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Login from './Login';
import Register from './Register';

const AuthPage = ({ initialView = 'login' }) => {
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(initialView !== 'register');

  const switchToLogin = () => setIsLogin(true);
  const switchToRegister = () => setIsLogin(false);

  useEffect(() => {
    if (location.pathname === '/register') {
      setIsLogin(false);
    } else if (location.pathname === '/login') {
      setIsLogin(true);
    }
  }, [location.pathname]);

  const inviteCode = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get('invite');
    return raw ? raw.trim().toUpperCase() : '';
  }, [location.search]);

  return (
    <>
      {isLogin ? (
        <Login onSwitchToRegister={switchToRegister} />
      ) : (
        <Register onSwitchToLogin={switchToLogin} inviteCode={inviteCode} />
      )}
    </>
  );
};

export default AuthPage;
